export default __webpack_public_path__ + "slices/main/assets/public/media/enso-favicon.021e0b8ef701152da14b5d6cd927843a.png";